export const msgFieldRequired = 'This field is required';
export const msgFieldInvalid = 'This field is invalid';
export const msgChooseOption = 'Choose one of the options';
export const msgInvalidEmail = 'Enter a valid email address';
export const msgTooManyRecipients = 'You can only send to one recipient';
